const MIN_SPEED_MS = 220;
const MAX_SPEED_MS = 500;
const SPEED_PER_SLIDE_MS = 90;

/**
 * Scales a swiper slideTo duration with the number of slides travelled, so a
 * jump across many tabs doesn't feel the same speed as moving to a neighbor.
 */
export const getSwiperSlideSpeed = (distance: number): number => {
	const slidesTravelled = Math.max(1, Math.abs(distance));
	return Math.min(
		MAX_SPEED_MS,
		Math.max(MIN_SPEED_MS, slidesTravelled * SPEED_PER_SLIDE_MS)
	);
};
